import { UitkFigureAspectRatioType } from "uitk-react-images";

const aspectRatioMap = {
  "1-1": UitkFigureAspectRatioType.R1_1,
  "4-3": UitkFigureAspectRatioType.R4_3,
  "3-2": UitkFigureAspectRatioType.R3_2,
  "16-9": UitkFigureAspectRatioType.R16_9,
  "21-9": UitkFigureAspectRatioType.R21_9,
  "3-4": UitkFigureAspectRatioType.R3_4,
};

export const getImageAspectRatio = (aspectRatio: string): UitkFigureAspectRatioType => {
  if (!aspectRatio) {
    return UitkFigureAspectRatioType.R4_3;
  }
  return aspectRatioMap[aspectRatio];
};
